import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
import DatePicker from 'vue2-datepicker'

Vue.component("downloadExcel", JsonExcel);
import moment from 'moment';
export default {
	name: 'activemrp',
	components: {
		Paginate,
		Loader,
		Pagination,
		JsonExcel,
		download,
		DatePicker
	},

	data: function() {
		return {
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// currentPage: 0,
			listboxdata: [],
			quantity: '',
			isLoading: false,
			resultCount: '',
			userid: '',
			clientsearch: '',
			warehousesearch: '',

			listClientData: [],
			listWarehouseData: [],
			// pageno: 0,
			// pageCount: 0,
			// pageLimit: 10,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			orderid:'',
			show:'',
			limitExeed:'',
			download: true,
			listReportDataforxls: [],
			csvFieldsForXls: {},
			reportname: '',
			packingbox:false,
			token: '',
			channellist : [],
			resultCount:0,
			selectedRow:null,
			selectedRows: {},
			Activemrplistlog:[],
			totalSku:0,
			selectedSku:0,
			showbutton:false,
			fromdate:'',
			todate:'',
			useremail:'',
			deletemodal:'',
			confirmationmodal: false
		}
	},

	created: function() {},
	filters: {
		moment: function(dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;
		this.useremail=userdetail.email;
		var userToken = window.localStorage.getItem('userToken')
		this.token = userToken.replace(/"/g, '')
		this.pageno = 0;

		this.reportname = 'Activemrp'
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				//this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();

				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

	},
	methods: {
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},



		////////
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'clientid': this.clientsearch ,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'warehouseid': this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// clientSelected() {
		// 	this.warehousesearch = '';
		// 				this.getWarehouseList();
		// },

		// warehouseSelected() {
		// 		this.warehouseid = this.warehousesearch;
		// 		if (this.warehouseid) {
		// 			if (!this.clientid) {
		// 				this.getClientList();

		// 		}
		// 	}
		// },
		async getActivemrp(){
			this.offset = 0;
			this.currentPage = 1;
			this.getboxdata()
		},
		calldateFunction() {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.todate = this.currentDate;
			this.fromdate = dt;
		},

		async getboxdata() {
			  var userToken = window.localStorage.getItem('userToken');
			  var myStr = userToken.replace(/"/g, '');
			  let listtype =''
			  if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			  let fromdate = ''
			  let todate = ''
			  if(this.packingbox){
				if (this.fromdate != null && this.fromdate != "") {
					fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
				}
				if (this.todate != null && this.todate != "") {
					todate = this.dateFormat(this.todate) + " 23:59:59";
				}

			  }

			  if(!this.packingbox){
				listtype ='mrpstockout'
			  }else{
				listtype ='mrplogreport'
			  }
			  this.isLoading = true
			  this.input = ({
				  "clientid": localStorage.getItem("selectedClient"),
				  "warehouseid":window.localStorage.getItem("selectedWarehouse"),
				  "productid": this.productid,
				  'offset': (this.currentPage - 1) * this.pageLimit,
					'limit': this.pageLimit,
				  "listtype":listtype
			  })
			  if(this.packingbox){
				this.input["fromdate"] = fromdate
				this.input["todate"] = todate
			  }
			let result= await axios({
					  method: 'POST',
					  'url': apiUrl.api_url + 'activeMrpStockoutreport',
					  'data': this.input,
					  headers: {
						  'Authorization': 'Bearer ' + myStr,
					  }
				  })
				  if(result.data.errorCode==0){
					if(!this.packingbox){
					const restructuredData = [];
					result.data.data.forEach(item => {
					  const existingItem = restructuredData.find(
						row => row.clientProductId === item.clientproductid
					  );
					  if (existingItem) {
						existingItem.subRows.push({
						  mrp: parseFloat(item.mrp),
						  qty: parseInt(item.qty)
						});
					  } else {
						restructuredData.push({
						  clientProductId: item.clientproductid,
						  Eancode: item.eancode,
						  Activemrp: parseFloat(item.activemrp),
						  StockOutdate: item.stockoutdate,
						  subRows: [
							{ mrp: parseFloat(item.mrp), qty: parseInt(item.qty) }
						  ]
						});
					  }
					  this.listboxdata = restructuredData
					  this.totalSku = result.data.data[0].skucount
					  this.setPageCounts(result.data.data[0].rowcount);
					  this.totalRows = Number(result.data.data[0].rowcount);
					});
				     }else{
						this.Activemrplistlog=result.data.data
						this.totalRows = Number(result.data.data[0].rowcount);
						this.setPageCounts(result.data.data[0].rowcount);
					}

					this.selectedSku = 0
					this.isLoading = false
					this.resultCount = this.listboxdata.length

				  }else{
					this.listboxdata=[]
					this.totalSku = this.listboxdata.length
					this.selectedSku = 0
					this.totalRows = 0
					this.$alertify.error(result.data.msg)
					this.Activemrplistlog=[]
					this.isLoading = false
					this.resultCount = 0
				  }
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		  getRadioGroupName(clientProductId) {
			this.selectedSku = Object.keys(this.selectedRows).length;
			if(this.selectedSku){
				this.showbutton =true
			}
			return `radio_${clientProductId}`;
		  },
		  async activateButtonClicked() {

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			let activemrpArr =[]
			if(this.confirmationmodal == false){
				this.confirmationmodal = true;
				return false;
			  }
			this.isLoading = true
			for (const clientProductId in this.selectedRows) {
			  const mrp = this.selectedRows[clientProductId];

			  activemrpArr.push(
				{clientProductid: clientProductId,newActivemrp:mrp}
			  )
			}
			 this.input={
				"clientid":localStorage.getItem("selectedClient"),
				"warehouseid":window.localStorage.getItem("selectedWarehouse"),
				"useremail":this.useremail,
				"activeMrp":activemrpArr
			}
			let result= await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'activeMrpChangeuniware',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(result.data.ErrorCode == 0){
				this.$alertify.success(result.data.msg)
				this.currentPage = 1
				this.selectedSku = 0
				this.selectedRows ={}
				this.confirmationmodal = false;
				this.getboxdata()
				this.isLoading = false
			}else{
				this.$alertify.error(result.data.msg)

			}

		  },

		onPageChange(page) {
			this.currentPage = page;
			this.getboxdata()
		},

		//Sets total number of pages
		setPageCounts(total_rows) {
			if (total_rows > 0) {
				if (total_rows <= this.pageLimit) {
					this.totalPage = 1;
				} else {
					this.totalPage = Math.ceil(total_rows / this.pageLimit);
				}
			} else {
				this.totalPage = 0;
			}
		},
		tabChanged(obj) {
			this.resetFormData()
			if (obj == 1) {
				this.packingbox = false;
			} else {
				this.packingbox = true;
			}

			if(this.packingbox){
				this.calldateFunction();
			}
		},
		resetFormData() {
			this.orderid='';
			this.totalRows = 0;
			this.clientsearch = '';
			this.warehousesearch = '';
			this.totalPage = 0;
			this.listboxdata = [];
			this.resultCount = 0;
			this.ClientErr = "";
			this.WarehouseErr = "";
			this.channellist = [];
			this.selectedSku=0;
			this.totalSku=0;
			this.showbutton=false;
			this.selectedRows = {};
			this.offset = 0;
			this.productid =''
			this.Activemrplistlog=[]
			this.todate = ''
			this.fromdate = ''
			this.confirmationmodal = false;
			let inputElement = document.getElementById('productid');
			let inputElement1 = document.getElementById('productid1');

			if (inputElement.value !== "") {
			  inputElement.value = "";
			}
			if (inputElement1.value !== "") {
				inputElement1.value = "";
			  }
			// if (this.user_type == 'warehouse_user') {
			// 	this.clientid = '';
			// } else if (this.user_type == 'client_user') {
			// 	this.warehouseid = '';
			// } else {
			// 	this.clientid = '';
			// 	this.warehouse = '';
			// 	this.warehouseid = '';
			// }
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/activemrp/activemrp.component.js